// externals
import { connect } from 'react-redux';

// components
import DxgMenuSummaryUI, { IDxgMenuUIProps } from './DxgMenuSummaryUI';

export const mapStateToProps = (state, props): IDxgMenuUIProps => {
    let hasUndefinedPrice = false;
    const dxgMenuItems = props.selector.getSelectedProtectionList(state);
    const term = props.selector.additionalSelectors.offerInfoSelectors.getSelectedTerm(state);
    const termLength = term?.months;
    let totalPrice = 0;
    let totalPerMonthPricePrecise = 0;
    dxgMenuItems.forEach((menuItem) => {
        const productPrice = menuItem.totalPrice ?? 0;
        const calculatedPerMonthPrice = productPrice / termLength;
        totalPrice += productPrice;
        totalPerMonthPricePrecise += menuItem.monthlyPrice ?? calculatedPerMonthPrice;
        hasUndefinedPrice = menuItem.totalPrice === undefined || menuItem.totalPrice === null;
    });

    if (!termLength) {
        return { totalPrice, hasUndefinedPrice };
    }

    const totalPerMonthPrice = Math.round(totalPerMonthPricePrecise);
    return { totalPerMonthPrice, hasUndefinedPrice };
};

const DxgMenuSummary = connect(mapStateToProps)(DxgMenuSummaryUI);

export default DxgMenuSummary;
